<template>
  <div class="container text-center bv">
    <div class="row align-items-center">
      <div class="col">
        <b-alert
          class="position-fixed fixed-top m-0 rounded-0 text-center"
          fade
          :show="dismissCountDown"
          :variant="errorMessage.color"
          @dismissed="dismissed"
        >
          {{ errorMessage.text }}
        </b-alert>
        <img
          src="@/assets/logo.png"
          fluid
          alt="Parceiro CAIXA"
          width="100"
          height="100"
        />

        <form
          @submit.prevent="handleResetPassword({ code: $route.query.oobCode, password: pass })"
          class="mt-3 form-signin"
        >
          <div class="mb-3">
            <h4>Olá! : )</h4>
            <span class="lead"> Entre com a sua conta.</span>
          </div>
          <div class="form-group mb-1">
            <input
              v-model="pass"
              type="password"
              class="form-control"
              placeholder="Sua senha"
            />
          </div>
          <button type="submit" class="btn btn-primary btn-block">
            Entrar
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'ResetPassword',
  data() {
    return {
      pass: ''
    };
  },
  methods: {
    ...mapActions(['handleResetPassword', 'recoveryPass', 'dismissed'])
  },
  computed: {
    ...mapState(['error', 'errorMessage', 'dismissCountDown'])
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bv .row {
  min-height: 100vh;
}
.form-signin {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: 0 auto;
}
</style>
